/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Warunki wynajmu') {
            document.title = 'Warunki wynajmu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>WARUNKI WYNAJMU</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Strona internetowa <a href="https://www.bbgreen.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            www.greenbb.pl
                        </Button>
                    </a> przeznaczona jest do rezerwacji noclegów w pokojach Green B&B.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Właścicielem serwisu oraz prezentowanych na stronie pokoi jest firma Green Sp. C. ul. Zjednoczenia 118, 65-001 Zielona Góra - Regon 540388581, NIP 9292087164. adres poczty elektronicznej: greenbb@greenbb.pl Numer rachunku bankowego mBank 36 10205402 00000202 5655578</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji apartamentów można dokonywać on-line za pośrednictwem serwisu lub telefonicznie  pod numerem <a href={`tel:${'+48576666506'}`} className={`${classes.email}`}>{'576 666 506'}</a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Warunkiem rezerwacji jest płatność on-line 100% ceny za wynajem w momencie rezerwacji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Możliwa jest płatność za rezerwację w obiekcie, przed zakwaterowaniem od poniedziałku do piątku po wcześniejszym umówieniu się na konkretną godzinę.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności jest <b>Autopay.</b></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji można również dokonywać przez portal rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności w przypadku rezerwacji przez serwis rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a> jest ten serwis.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W obiekcie akceptujemy karty płatnicze.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zakwaterowanie w pokojach odbywa się bezobsługowo na podstawie szczegółowych instrukcji oraz kodów dostępu wysyłanych w wiadomości sms.
                        <br/>Gość otrzymuje kod dostępu do drzwi głównych wejściowych oraz do skrytki, znajdującej się w holu recepcyjnym. Po wpisaniu kodu Gość otworzy skrytkę, w której będą klucze do pokoju. Zakwaterowanie jest możliwe od godziny 13:00, wymeldowanie do godz. 11:00 ostatniego dnia pobytu .</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji na dwa lub więcej dni przed przyjazdem, Gość otrzyma pełny zwrot wpłaconych środków pomniejszonych o prowizję operatora płatności. Zwrot będzie wykonany w ciągu maksymalnie 7 dni roboczych na wskazany rachunek bankowy. W przypadku anulowania na mniej niż 1 dni przed przyjazdem, rezerwacja jest bezzwrotna.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszelkie reklamacje powinny być zgłaszane mailowo na adres <a href={`mailto:${'greenbb@greenbb.pl'}`} target='_blank' className={`${classes.email}`}>{'greenbb@greenbb.pl'}</a>. Czas odpowiedzi na reklamację wynosi do 7 dni roboczych.</Typography></li>
                </ol>
                
            
                {/* <br /><Typography align="right" gutterBottom>Dyrektor PPUH Hayduk</Typography>
                <Typography align="right" gutterBottom><b>Koralewska Monika</b></Typography> */}
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
